import React, { useState } from "react";
import ProcurementMetricsAnylysis from "./GnaMetrics";

export default function MetricsProcurement({refreshKey, activeTab, setActiveTab} : { refreshKey:any, activeTab:any, setActiveTab:(tab: string) => void }) {
  const [error, setError] = useState<string | null>(null);
  const [selectedBlock, setSelectedBlock] = useState<any[]>([]);
  return (
    <>
      <ProcurementMetricsAnylysis
        selectedBlock={selectedBlock}
        refreshKey={refreshKey}
        setError={setError}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />
    </>
  );
}
